import { GoogleGlobalSiteTagPageCommand } from 'backend';
import {
  GTAG_PAGE_COMMAND_TYPE,
  MeasurementSettingHandledByGtag,
} from '../models';
import { createWithSendTo, getId } from './shared';

const executePageCommand = (
  id: string,
  pageCommand: GoogleGlobalSiteTagPageCommand,
): void => {
  const withSendTo = createWithSendTo(id);
  switch (pageCommand.commandType) {
    case GTAG_PAGE_COMMAND_TYPE.config: {
      const { commandType, additionalConfig } = pageCommand;
      window.gtag(commandType, id, additionalConfig);
      return;
    }
    case GTAG_PAGE_COMMAND_TYPE.consent: {
      const { commandType, consentArg, consentParams } = pageCommand;
      // 型エラーになるが、@types/gtag.jsの方が古い
      window.gtag(commandType, consentArg, consentParams as any);
      return;
    }
    case GTAG_PAGE_COMMAND_TYPE.event: {
      const { commandType, eventName, eventParameterValues } = pageCommand;
      if (eventParameterValues) {
        window.gtag(commandType, eventName, withSendTo(eventParameterValues));
        return;
      }
      window.gtag(commandType, eventName);
      return;
    }
    case GTAG_PAGE_COMMAND_TYPE.get: {
      // getはcallback関数が必要だが、evalするわけにもいかないため無視する
      return;
    }
    case GTAG_PAGE_COMMAND_TYPE.set: {
      const { commandType, parameterValues } = pageCommand;
      window.gtag(commandType, withSendTo(parameterValues));
      return;
    }
    default: {
      const x: never = pageCommand;
      console.error(`${x} is unknown command type.`);
    }
  }
};

const handleSetting = (setting: MeasurementSettingHandledByGtag) => {
  if (!setting.pageCommands.length) {
    return;
  }
  const id = getId(setting);
  const { pageCommands } = setting;
  pageCommands.forEach((pageCommand) => {
    executePageCommand(id, pageCommand);
  });
};

type ExecuteGtagPayload = {
  settings: MeasurementSettingHandledByGtag[];
};
export const executeGtag = ({ settings }: ExecuteGtagPayload): void => {
  if (!window.gtag) {
    return;
  }
  settings.forEach((setting) => {
    handleSetting(setting);
  });
};
